import { baseAxios } from "config";

const fetchOnboardingLog = async (params = {}) => {
  const { page = 1, limit = 50, startDate, endDate } = params;

  const queryParams = new URLSearchParams();

  if (page) queryParams.append("page", page);
  if (limit) queryParams.append("limit", limit);
  if (startDate) queryParams.append("startDate", startDate);
  if (endDate) queryParams.append("endDate", endDate);

  const response = await baseAxios.get(`/applicants/onboarding-log?${queryParams.toString()}`);
  return response.data;
};

export default fetchOnboardingLog;
